import {Box, Center, Image} from 'platform/foundation';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {CarPassState} from '../utils/deriveCarPassState';

interface CarPassLogoProps {
  state: CarPassState;
}

const CHECK_CAR_PASS_LOGO_GREEN = '/assets/images/checkcar_pass_logo_green.png';
const CHECK_CAR_PASS_LOGO_GREY = '/assets/images/checkcar_pass_logo_grey.png';
const CHECK_CAR_PASS_LOGO_ORANGE = '/assets/images/checkcar_pass_logo_orange.png';
const CHECK_CAR_PASS_LOGO_RED = '/assets/images/checkcar_pass_logo_red.png';

const getLogoSrc = (state: CarPassState): string =>
  match<CarPassState, string>(state)
    .with(CarPassState.READY, () => CHECK_CAR_PASS_LOGO_GREEN)
    .with(
      CarPassState.PENDING,
      CarPassState.WAITING_FOR_DIV,
      CarPassState.ACTION_TAKEN,
      () => CHECK_CAR_PASS_LOGO_ORANGE
    )
    .with(CarPassState.ACTION_REQUIRED, CarPassState.FAILED, () => CHECK_CAR_PASS_LOGO_RED)
    .with(CarPassState.NONE, CarPassState.EXPIRED, () => CHECK_CAR_PASS_LOGO_GREY)
    .exhaustive();

export function CarPassLogo(props: CarPassLogoProps) {
  return (
    <Box backgroundColor="general.white" width="100%" height="100%">
      <Center width="100%" height="100%">
        <Box width="80%" height="80%">
          <Image
            src={getLogoSrc(props.state)}
            alt={i18n.t('page.carPass.labels.widgetTitle')}
            width="100%"
            height="100%"
            fit="contain"
          />
        </Box>
      </Center>
    </Box>
  );
}
